import React from 'react'
import './style.css'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { Document, Page } from 'react-pdf'
import styled from '@emotion/styled'
import { Media } from 'react-breakpoints'
import Wrapper from './Wrapper'
import KartenMobile from './karten-300-mobile'
import KartenDesktop from './karten-600-desktop'

const DocWrapper = styled.div`
  /*   width: calc(100% - 10%); */
  max-width: 1110px;
  margin-bottom: 4em;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  font-size: 19px;
`
const Background = styled.div`
  background-color: #1e1e1e;
`

const Paragraph = styled.p`
  color: white;
  font-family: 'Didot Medium';
  font-size: 1.2em;
  text-align: center;
  @media (max-width: 649px) {
    margin-top: 2em;
  }
  @media (min-width: 650px) {
    max-width: 600px;
    margin: 1em auto 3em;
  }
`
const SvgContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  @media (max-width: 650px) {
    svg {
      width: 50%;
    }
  }
`
const Spacer = styled.div`
  padding: 2em;
`
const Karten = ({ kartenText, children }) => (
  <Background>
    <SvgContainer>
      <svg
        id="karte"
        width="379px"
        height="221px"
        viewBox="0 0 379 221"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.434802827">
          <g
            id="Cafe-Black-Large-Desktop-"
            transform="translate(-1193.000000, -3023.000000)"
            fill="#8E5949"
            fillRule="nonzero"
          >
            <path
              d="M1249.1,3180 C1249.32,3180 1249.32,3174.72 1249.1,3174.72 L1234.14,3174.72 C1233.04,3174.72 1232.82,3174.5 1232.82,3173.84 L1232.82,3092.44 C1232.82,3091.78 1233.04,3091.56 1234.14,3091.56 L1249.1,3091.56 C1249.32,3091.56 1249.32,3086.28 1249.1,3086.28 L1193.66,3086.28 C1193.22,3086.28 1193.22,3091.56 1193.66,3091.56 L1208.4,3091.56 C1209.28,3091.56 1209.72,3091.78 1209.72,3092.44 L1209.72,3173.84 C1209.72,3174.5 1209.28,3174.72 1208.4,3174.72 L1193.66,3174.72 C1193.22,3174.72 1193.22,3180 1193.66,3180 L1249.1,3180 Z M1298.91778,3243.14 C1334.99778,3243.14 1356.99778,3197.38 1356.99778,3151.62 C1356.99778,3104.1 1335.21778,3084.3 1307.71778,3084.3 C1281.09778,3084.3 1261.29778,3105.64 1261.29778,3131.16 C1261.29778,3156.9 1281.09778,3178.24 1307.71778,3178.24 C1317.39778,3178.24 1327.51778,3174.06 1331.25778,3166.14 C1329.71778,3205.96 1323.55778,3237.86 1298.91778,3237.86 C1291.43778,3237.86 1286.59778,3233.46 1286.59778,3225.76 C1286.59778,3222.24 1288.35778,3220.7 1288.35778,3216.96 C1288.35778,3212.78 1285.49778,3208.38 1278.01778,3208.38 C1270.75778,3208.38 1267.89778,3213.88 1267.89778,3219.16 C1267.89778,3227.3 1279.55778,3243.14 1298.91778,3243.14 Z M1307.71778,3172.96 C1301.55778,3172.96 1297.59778,3171.86 1293.85778,3168.56 C1287.25778,3163.06 1285.49778,3150.96 1285.49778,3131.16 C1285.49778,3108.5 1287.25778,3099.26 1293.85778,3093.76 C1297.59778,3090.46 1301.55778,3089.36 1307.71778,3089.36 C1314.09778,3089.36 1319.15778,3090.46 1323.11778,3093.76 C1329.71778,3099.26 1333.01778,3108.06 1333.01778,3130.72 C1333.01778,3138.64 1332.35778,3155.58 1331.47778,3158.66 C1329.27778,3164.82 1322.45778,3172.96 1307.71778,3172.96 Z M1418.25556,3181.98 C1443.77556,3181.98 1464.45556,3161.3 1464.45556,3136.88 C1464.45556,3112.68 1443.77556,3092 1418.25556,3092 C1410.11556,3092 1400.21556,3095.74 1394.93556,3103.88 C1396.03556,3062.52 1403.73556,3028.2 1426.17556,3028.2 C1432.11556,3028.2 1436.29556,3031.72 1436.29556,3039.42 C1436.29556,3043.38 1434.53556,3044.7 1434.53556,3048.44 C1434.53556,3052.62 1437.83556,3056.8 1445.09556,3056.8 C1452.57556,3056.8 1454.99556,3051.3 1454.99556,3046.24 C1454.99556,3038.1 1443.99556,3023.36 1426.17556,3023.36 C1392.73556,3023.36 1371.17556,3069.56 1371.17556,3115.32 C1371.17556,3161.08 1391.41556,3181.98 1418.25556,3181.98 Z M1418.25556,3176.7 C1412.97556,3176.7 1408.35556,3175.82 1404.61556,3172.74 C1398.67556,3167.68 1395.15556,3159.54 1395.15556,3137.98 L1395.15556,3115.54 C1395.15556,3106.96 1405.05556,3097.28 1418.25556,3097.28 C1424.19556,3097.28 1428.37556,3097.94 1432.11556,3101.24 C1438.27556,3106.3 1440.47556,3118.4 1440.47556,3136.88 C1440.47556,3158.44 1438.27556,3167.68 1432.11556,3172.74 C1428.37556,3175.82 1424.19556,3176.7 1418.25556,3176.7 Z M1525.27334,3181.98 C1550.79334,3181.98 1571.47334,3161.3 1571.47334,3136.88 C1571.47334,3112.68 1550.79334,3092 1525.27334,3092 C1517.13334,3092 1507.23334,3095.74 1501.95334,3103.88 C1503.05334,3062.52 1510.75334,3028.2 1533.19334,3028.2 C1539.13334,3028.2 1543.31334,3031.72 1543.31334,3039.42 C1543.31334,3043.38 1541.55334,3044.7 1541.55334,3048.44 C1541.55334,3052.62 1544.85334,3056.8 1552.11334,3056.8 C1559.59334,3056.8 1562.01334,3051.3 1562.01334,3046.24 C1562.01334,3038.1 1551.01334,3023.36 1533.19334,3023.36 C1499.75334,3023.36 1478.19334,3069.56 1478.19334,3115.32 C1478.19334,3161.08 1498.43334,3181.98 1525.27334,3181.98 Z M1525.27334,3176.7 C1519.99334,3176.7 1515.37334,3175.82 1511.63334,3172.74 C1505.69334,3167.68 1502.17334,3159.54 1502.17334,3137.98 L1502.17334,3115.54 C1502.17334,3106.96 1512.07334,3097.28 1525.27334,3097.28 C1531.21334,3097.28 1535.39334,3097.94 1539.13334,3101.24 C1545.29334,3106.3 1547.49334,3118.4 1547.49334,3136.88 C1547.49334,3158.44 1545.29334,3167.68 1539.13334,3172.74 C1535.39334,3175.82 1531.21334,3176.7 1525.27334,3176.7 Z"
              id="1966"
            />
          </g>
        </g>
      </svg>
    </SvgContainer>
    <Wrapper>
      <Paragraph>{kartenText.karte.text}</Paragraph>
    </Wrapper>

    {children}
  </Background>
)

export default Karten
